/**
 * 校验规则上下文：默认规则 + @app 应用层覆写
 * 默认规则是追加合并（数组 concat），但 commonPassword 使用覆盖
 *
 * 1:1 还原参考项目 @pkg/diffconfig/src/diffValidators.js
 */
import { FIELD_RULES as appRules } from '@app/config/validators'
import { FIELD_RULES as standardRules } from './config/validators'

// 合并：标准规则 + 应用规则
const allKeys = new Set([...Object.keys(standardRules), ...Object.keys(appRules)])

export const FIELD_RULES: Record<string, any[]> = {}

allKeys.forEach((key) => {
  // commonPassword 使用覆盖而不是合并
  if (key === 'commonPassword' && appRules[key] && appRules[key].length > 0) {
    FIELD_RULES[key] = appRules[key]
  } else {
    // 其他规则追加合并
    FIELD_RULES[key] = [...(standardRules[key] || []), ...(appRules[key] || [])]
  }
})
